import styled, { css } from 'styled-components';
import { rem } from '@packages/ui/tokens/spacing';

/** Legacy reports toolbar: 190px type select + search at ~2:1 width (grid-cols-3). */
export const TOOLBAR_PREFIX_SELECT_WIDTH_PX = 190;

/** Wraps {@link TableToolbar} `renderToolbarPrefix`. */
export const ToolbarPrefixSlot = styled.div`
  flex-shrink: 0;
  width: ${TOOLBAR_PREFIX_SELECT_WIDTH_PX}px;

  & > * {
    margin-bottom: 0;
    width: 100%;
  }
`;

/** Prefix + search only (reports-style). Default toolbar search skips this wrapper. */
export const ToolbarSearchGroup = styled.div<{ $attached: boolean }>`
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0;

  ${({ $attached }) =>
    $attached &&
    css`
      display: grid;
      grid-template-columns: ${TOOLBAR_PREFIX_SELECT_WIDTH_PX}px minmax(0, 2fr);
      width: 100%;
      max-width: ${rem(640)};

      @media (min-width: 768px) {
        min-width: ${rem(400)};
      }

      ${ToolbarPrefixSlot} [class*='-control'] {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }

      .custom-search {
        min-width: 0;
        width: 100%;
      }

      /* Match DS Select control: --ui-input-border + drop-shadow (Search default uses --ui-border-muted). */
      .custom-search input {
        border: ${rem(1)} solid var(--ui-input-border, var(--ui-border, #d9d9d9));
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        margin-left: ${rem(-1)};
        width: 100%;
        box-shadow: none;
        filter: drop-shadow(
          ${rem(0)} ${rem(2)} ${rem(4)} var(--ui-input-shadow, var(--ui-shadow-default, rgba(0, 0, 0, 0.12)))
        );
      }

      .custom-search input:hover,
      .custom-search input:focus {
        border-color: var(--ui-input-border-focus, var(--ui-interactive, #1a73e8));
        outline: none;
      }
    `}
`;
